import { render, staticRenderFns } from "./StepFinal.vue?vue&type=template&id=45b35043&scoped=true"
import script from "./StepFinal.vue?vue&type=script&lang=js"
export * from "./StepFinal.vue?vue&type=script&lang=js"
import style0 from "./StepFinal.vue?vue&type=style&index=0&id=45b35043&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b35043",
  null
  
)

export default component.exports